import logger from 'helpers/logger';
import { capitalizeFirstLetter } from 'helpers/string';
import * as PageTypes from 'features/PageTypes';

export const PageTypeFeature: React.FC<Content.Page> = (page) => {
	const production = process.env.NODE_ENV === 'production';
	const featureName = `${capitalizeFirstLetter(page.template)}PageFeature`;
	const PageTypeTemplate = PageTypes[featureName];


	if (!PageTypeTemplate) {
		const message = `PageType [${page.template}] is missing a React Component. Add missing export '${featureName}' from /features`;
		logger.error(message);
		if (!production) {
			return <div>{message}</div>;
		} else {
			return null;
		}
	}

	return <PageTypeTemplate {...page} />;
};
